import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Sidante sur la frunto de nealta homo, la Akno envie rigardas al la fruntoj de altstaturaj homoj kaj pensas:
		</p>
		
		<p class="mb-3">
			- Se mi atingus tian altan staton!
		</p>
		`
	)
}

const itemName = {
	esp: 'La akno'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;